"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Donation = void 0;
var PreludeCard_1 = require("./PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Donation = (function (_super) {
    __extends(Donation, _super);
    function Donation() {
        return _super.call(this, {
            name: CardName_1.CardName.DONATION,
            metadata: {
                cardNumber: 'P08',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(21);
                }),
                description: 'Gain 21 M€.',
            },
        }) || this;
    }
    Donation.prototype.play = function (player) {
        player.megaCredits += 21;
        return undefined;
    };
    return Donation;
}(PreludeCard_1.PreludeCard));
exports.Donation = Donation;
//# sourceMappingURL=Donation.js.map